export const widgetKeys = {
  REQUEST_STATS: 'clients_requestStats',
  THREAT_STATS: 'clients_campusStats',
  PERFORMANCE_STATS: 'clients_performanceStats',
  SESSIONS: 'clients_sessions',
};
